import { Chain, ChainType } from '@/generated/proto/bridge/models/chain'
import { ProtobufAnyMessage } from '@/types'

export interface InsertChainFormValues {
  creator: string
  chain: {
    id: string
    type: ChainType
    bridgeAddress: string
    operator: string
    confirmations: string | number
    name: string
  }
}

export interface DeleteChainFormValues {
  creator: string
  chainId: string
}

export function buildInsertChainMessage(values: InsertChainFormValues): {
  messages: ProtobufAnyMessage[]
} {
  const confirmations =
    typeof values.chain.confirmations === 'string'
      ? parseInt(values.chain.confirmations, 10)
      : values.chain.confirmations

  const chainPayload: Chain = {
    id: values.chain.id,
    type: values.chain.type,
    bridgeAddress: values.chain.bridgeAddress,
    operator: values.chain.operator,
    confirmations,
    name: values.chain.name,
  }

  return {
    messages: [
      {
        '@type': '/core.bridge.MsgInsertChain',
        creator: values.creator,
        chain: chainPayload,
      },
    ],
  }
}

export function buildDeleteChainMessage(values: DeleteChainFormValues): {
  messages: ProtobufAnyMessage[]
} {
  return {
    messages: [
      {
        '@type': '/core.bridge.MsgDeleteChain',
        creator: values.creator,
        chainId: values.chainId,
      },
    ],
  }
}
